// Entry point: mount the app, register the service worker, take in shared photos.

import m from "mithril";
import { App } from "./components/App.js";
import { store } from "./models/store.js";
import { consumeSharedImage } from "./services/share.js";
import { scan } from "./services/scan.js";

const root = document.getElementById("app");
if (root) m.mount(root, App);

// A small handle for debugging in the console (and for tests). Harmless in prod.
(window as unknown as { tally: unknown }).tally = { store, scan };

// Register the service worker (share target + offline). Non-fatal if it fails.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("./sw.js").catch(() => {
      /* offline & share target just won't be available; the app still works */
    });
  });
}

// If we were launched as a share target, load the shared photo and scan it.
consumeSharedImage()
  .then((blob) => {
    if (blob) {
      store.setStatus("Loading shared photo…");
      return store.loadImage(blob).then(() => scan(false));
    }
    return undefined;
  })
  .catch(() => undefined);
